import { useForm } from '@tanstack/react-form'
import { getRouteApi } from '@tanstack/react-router'
import { FF } from 'ui/components'
import { Select } from 'ui/components/Select'
import { AdverseMediaDetailsType } from '~bank-adverse-media/types/details'

import { s } from './styles'

const routeApi = getRouteApi('/_app/adverse-media/$id')

export const Filter = () => {
  const navigate = routeApi.useNavigate()

  const data = routeApi.useLoaderData() as AdverseMediaDetailsType
  const searchParams = routeApi.useSearch()

  const formApi = useForm({
    defaultValues: {
      publicationsStatus:
        searchParams.publicationsStatus === undefined
          ? (data?.publicationStatusOptions[1].value as string)
          : searchParams.publicationsStatus
    },
    validators: {
      onChange: ({ value }) => {
        navigate({ to: '.', search: (prev) => ({ ...prev, publicationsPage: 1, ...value }), resetScroll: false })
        return undefined
      }
    }
  })

  return (
    <s.FilterContainer>
      <formApi.Field
        name="publicationsStatus"
        children={(field) => (
          <FF
            field={field}
            input={(inputProps) => (
              <Select label="Publication status" data={data?.publicationStatusOptions} {...inputProps} />
            )}
          />
        )}
      />
    </s.FilterContainer>
  )
}
